import { action, observable } from 'mobx'

export class GoodsLibraryStore {
    @observable
    public groupId: number | undefined = undefined // 一级分组ID

    @observable
    public secondGroupId?: number // // 二级分组ID

    @observable
    public keyWord: string = '' // 商品搜索关键字

    @observable
    public status: boolean = true // 显示未上架商品

    @observable
    public updateGroupStatus?: boolean = false // 用于刷新当前选中分组的商品信息

    @observable
    public resetSatus: boolean = false // 重置分组选中并刷新

    @observable
    public updateGroup: boolean = false // 刷新分组

    @observable
    public groupIds: number[] = [] // 根据分组筛选

    @observable
    public clearSelectKey: boolean = false

    @observable
    public selectGroupNum: Record<number, number | Record<number, number>> = {} //   分组选中的数量

    @observable
    public selectNum: number = 0 // 全部商品选中的数量

    @action
    public resetSelectGroupNum(q: Record<number, number | Record<number, number>> = {}) {
        this.selectGroupNum = q
    }

    @action
    public setSelectGroupNum(val: number) {
        if (this.groupId) {
            if (this.secondGroupId) {
                if (!this.selectGroupNum[this.groupId]) {
                    this.selectGroupNum = {
                        ...this.selectGroupNum,
                        [this.groupId]: {
                            [this.secondGroupId]: val,
                        },
                    }
                } else {
                    this.selectGroupNum = {
                        ...this.selectGroupNum,
                        [this.groupId]: {
                            ...(this.selectGroupNum[this.groupId] as Record<number, number>),
                            [this.secondGroupId]: val,
                        },
                    }
                }
            } else {
                this.selectGroupNum = {
                    ...this.selectGroupNum,
                    [this.groupId]: val,
                }
            }
        }
    }

    @action
    public setAllSelectNum(val: number) {
        this.selectNum = val
    }

    @action
    public setClearSelectKey(clear: boolean) {
        this.clearSelectKey = clear
    }

    @action
    public setUpdateGroup() {
        this.updateGroup = !this.updateGroup
    }

    @action
    public setGroupIds(groupsIds: number[]) {
        this.groupIds = groupsIds
    }

    @action
    public resetGoodTableData() {
        this.resetSelectGroupNum()
        this.setClearSelectKey(true)
        this.secondGroupId = 0
        this.groupId = 0
        this.resetSatus = !this.resetSatus
    }

    @action
    public setActiveGroupId(id: number | undefined) {
        this.groupId = id
    }

    @action
    public setActiveSecondGroupId(id?: number) {
        this.secondGroupId = id
    }

    @action
    public setUpdateGroupStatus(status?: boolean) {
        this.resetSelectGroupNum()
        this.setClearSelectKey(true)
        if (status) {
            this.updateGroupStatus = status
        } else {
            this.updateGroupStatus = !this.updateGroupStatus
        }
    }

    @action
    setKeyWord(keyWord: string) {
        this.keyWord = keyWord
    }

    @action
    changeStatus(status: boolean) {
        this.status = status
    }
}

export const goodsLibraryStore = new GoodsLibraryStore()
